export default __webpack_public_path__ + "static/media/small-dashboard.2bc1f70a.svg";